import { render, staticRenderFns } from "./SetWeight.vue?vue&type=template&id=7c7ecdb6&scoped=true"
import script from "./SetWeight.vue?vue&type=script&lang=js"
export * from "./SetWeight.vue?vue&type=script&lang=js"
import style0 from "./SetWeight.vue?vue&type=style&index=0&id=7c7ecdb6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ecdb6",
  null
  
)

export default component.exports